// Codigo de acesso digitado na tela de login (spec 2026-10-27-login-por-codigo-no-celular).
//
// O tamanho NAO e presumido: a documentacao do Supabase diz 6 digitos e a medicao de 15/09 achou 8 neste projeto.
// Aqui so se limpa o que o e-mail e a area de transferencia costumam trazer junto e se confere que sobraram digitos.
// Quem decide se o codigo esta certo e o servidor (verifyOtp).

// Espaco (inclusive o nao separavel), caractere invisivel (zero-width, BOM), traco ASCII e todos os tracos Unicode (U+2010 a U+2015).
// Escrito em \u para o arquivo nao depender de caractere invisivel no fonte.
const SOBRA = /[\s\u200B-\u200D\uFEFF\u2010-\u2015-]/g;

export function limparCodigo(bruto) {
  return String(bruto ?? '').replace(SOBRA, '');
}

export function codigoValido(limpo) {
  return /^\d+$/.test(limpo);
}
